import {Component} from '@angular/core';
import {MarketService} from "../../services/market/market.service";
import {Observable} from "rxjs";
import {IBid} from "../../services/market/market.interface";

@Component({
  selector: 'app-bids',
  templateUrl: './bids.component.html',
  styleUrls: ['./bids.component.scss']
})
export class BidsComponent {

  public bids$: Observable<IBid> = this.marketService.bids$;

  constructor(private marketService: MarketService) {
    this.marketService.requestBids();
  }

}
